import { Type, type Static } from '@sinclair/typebox';
import { FileUploadSchema } from '../../shared/file/file-request.schema';

export const CreateStoryBaseBodySchema = Type.Object(
  {
    attachment: FileUploadSchema,
    text: Type.Optional(
      Type.String({
        description:
          'Optional caption for the story. User mentions can be added by inserting an @ followed by the ID or public identifier of the user (example: @JohnDoe), if supported by the provider.',
      }),
    ),
    specifics: Type.Optional(Type.Any()),
  },
  { additionalProperties: false, description: 'A story supports exactly one image or video attachment.' },
);

export type CreateStoryBaseBody<Specifics = object> = Omit<Static<typeof CreateStoryBaseBodySchema>, 'specifics'> & {
  specifics?: Specifics;
};
